export interface ShareData {
    title: string;
    url: string;
    text: string;
}

window.addEventListener('load', () => {
    const buttons = document.querySelectorAll("[data-share-button]");

    function hideShareButton(button: HTMLElement) {
        button.classList.add('hidden');
    }

    function canShare(data: ShareData) {
        if (navigator.canShare) {
            return navigator.canShare(data);
        }
        return false;
    }


    function initializeShareButton(button: HTMLElement) {
        // build share data
        const title = button.getAttribute('data-share-title') || false;
        const url = button.getAttribute('data-share-url') || false;
        const text = button.getAttribute('data-share-text') || false;
        if (!title || !url || !text) {
            hideShareButton(button);
            return;
        }

        const shareData: ShareData = {
            title: title,
            url: url,
            text: text
        };

        if (!canShare(shareData)) {
            hideShareButton(button);
            return;
        }

        button.classList.remove('hidden');

        button.addEventListener('click', async (e) => {
            e.preventDefault();
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error('Error sharing:', err);
            }
        });
    }

    buttons.forEach(button => {
        initializeShareButton(button as HTMLElement);
    });
});
